import { Component, Input } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    selector: "app-confirm-delete-modal",
    templateUrl: "./confirm-delete-modal.component.html",
    styleUrls: ["./confirm-delete-modal.component.scss"],
    standalone: false,
})
export class ConfirmDeleteModalComponent {
    @Input() title: string = "Confirm delete"
    @Input() message: string = "Are you sure you want to delete?"
    @Input() deleteCallback: CallableFunction = (event) => {}
    @Input() confirmButtonClass: string = "btn-primary"

    constructor(public activeModal: ModalRef) {}
}
